import { render } from "./Marketplace.vue?vue&type=template&id=b25bed22"
import script from "./Marketplace.vue?vue&type=script&lang=js"
export * from "./Marketplace.vue?vue&type=script&lang=js"

import "./Marketplace.vue?vue&type=style&index=0&id=b25bed22&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__